import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiService from "../api/ApiService";
import "../css/app.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default function RathYatraRegister() {
  const { t } = useTranslation();
  const [templeListArray, setfetchTempleListDB] = useState([]);
  const [stateListArray, setfetchStateListDB] = useState([]);
  const [searchTemple, setSearchTemple] = useState(""); // Temple search term
  const [searchState, setSearchState] = useState("");
  const [selectedImages, setSelectedImages] = useState(null);
  const [numberValue, setNumberValue] = useState("");
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpInput, setOtpInput] = useState("");

  console.log("stateListArray", stateListArray, templeListArray);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    temple_name: "",
    mediaCoverage: "",
    personality: "",
    zone: "",
    catogory: "",
    state: "",
    userrole: "",
    customTemple: "", // For custom temple input field when "Other" is selected
    count: "", // <-- Add this
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleCheckboxChange = (e, zone) => {
    const selectedZones = formData.selectedZones || [];
    if (e.target.checked) {
      setFormData({ ...formData, selectedZones: [...selectedZones, zone] });
    } else {
      setFormData({
        ...formData,
        selectedZones: selectedZones.filter((z) => z !== zone),
      });
    }
  };

  const fetchTempleList = async () => {
    try {
      const res = await ApiService.fetchTempleList();
      setfetchTempleListDB(res); // Assuming response is the list of temples
    } catch (error) {
      console.log(error);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImages(file);
    }
  };

  const fetchStateList = async () => {
    try {
      const res = await ApiService.fetchStateList();
      setfetchStateListDB(res); // Assuming response is the list of temples
    } catch (error) {
      console.log(error);
    }
  };

  const handleOtpVerifyAndSubmit = async () => {
    if (!otpInput) {
      toast.error("Please enter OTP");
      return;
    }

    try {
      const submissionData = new FormData();

      for (let key in formData) {
        submissionData.append(key, formData[key]);
      }

      // Append OTP
      submissionData.append("otp", otpInput);

      // Append image
      if (selectedImages) {
        selectedImages.forEach((image) => {
          submissionData.append("images", image); // key must match multer field name
        });
      }

      const response = await ApiService.rathYatraData(submissionData);

      toast.success("Form submitted successfully!");
      setShowOtpModal(false);
      setIsSubmitted(true);
    } catch (error) {
      console.error("OTP Verify Error:", error);
      if (error.response?.status === 403) {
        toast.error("Data for this temple already exists");
      } else {
        toast.error("Submission failed");
      }
    }
  };

  const handleTempleChange = (e) => {
    const { name, value } = e.target;

    if (name === "temple_name") {
      const selectedTemple = templeListArray.find(
        (t) => t.templeName === value
      );

      if (value === "Other") {
        // Reset state, zone, category when "Other" is selected
        setFormData((prev) => ({
          ...prev,
          temple_name: "Other",
          zone: "",
          state: "",
          catogory: "",
        }));
      } else if (selectedTemple) {
        setFormData((prev) => ({
          ...prev,
          temple_name: selectedTemple.templeName,
          zone: selectedTemple.templeDivision || "", // or templeZone
          state: selectedTemple.templeState || "",
          catogory: selectedTemple.templePTC || "",
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
    } else {
      // Handle all other fields normally
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // List of required fields (except 'personality')
    const requiredFields = [
      { key: "name", label: "Name" },
      { key: "phone", label: "Phone Number" },
      { key: "temple_name", label: "Temple Name" },
      { key: "zone", label: "Zone" },
      { key: "catogory", label: "Category" },
      { key: "state", label: "State" },
      { key: "mediaCoverage", label: "Media Coverage" },
      { key: "count", label: "Count" },
    ];
  
    for (const field of requiredFields) {
      const value = formData[field.key];
    
      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && value.trim() === "") ||
        (typeof value !== "string" && value === "")
      ) {
        toast.error(`Please enter ${field.label}`);
        return;
      }
    }    
    try {
      const data = {
        phone: formData.phone,
        name: formData.name,
      };
      await ApiService.sendRathOtp(data); // Step 2: Send OTP
      toast.success("OTP sent to your phone number");
      setShowOtpModal(true); // Step 3: Open Modal
    } catch (error) {
      toast.error("Failed to send OTP");
      console.error("OTP Send Error:", error);
    }
  };

  //   const handleSubmit = async (e) => {
  //     e.preventDefault();
  //     console.log("Form Submitted: ", formData);

  //     try {
  //       const submissionData = new FormData();

  //       // Append all text fields
  //       for (let key in formData) {
  //         submissionData.append(key, formData[key]);
  //       }

  //       // Append images (multiple)
  //       selectedImages.forEach((image) => {
  //         submissionData.append("images", image); // key must match multer field name
  //       });

  //       const response = await ApiService.rathYatraData(submissionData);
  //       console.log("API Response:", response);
  //       setIsSubmitted(true);
  //     } catch (error) {
  //       console.error("Error:", error);

  //       if (error.response && error.response.status === 400) {
  //         if (
  //           error.response.data.message ===
  //           "User with this phone number already exists"
  //         ) {
  //           toast.error("User with this phone number already exists");
  //         } else {
  //           toast.error("Bad Request: " + error.response.data.message);
  //         }
  //       } else {
  //         toast.error("An unexpected error occurred");
  //       }
  //     }
  //   };

  //   const handleSubmit = async (e) => {
  //     e.preventDefault();
  //     console.log("Form Submitted: ", formData);
  //     try {
  //       const response = await ApiService.registerUser(formData);
  //       console.log("API Response:", response);
  //       setIsSubmitted(true);
  //     } catch (error) {
  //       console.error("Error:", error);

  //       if (error.response && error.response.status === 400) {
  //         if (
  //           error.response.data.message ===
  //           "User with this phone number already exists"
  //         ) {
  //           toast.error("User with this phone number already exists");
  //         } else {
  //           toast.error("Bad Request: " + error.response.data.message);
  //         }
  //       } else {
  //         toast.error("An unexpected error occurred");
  //       }
  //     }
  //   };

  useEffect(() => {
    fetchTempleList();
    fetchStateList();
  }, []);

  const filteredTemples = templeListArray
    .filter((temple) =>
      temple.templeName.toLowerCase().includes(searchTemple.toLowerCase())
    )
    .sort((a, b) => a.templeName.localeCompare(b.templeName)); // Sort temples alphabetically

  const filteredStates = stateListArray
    .filter((state) =>
      state.name.toLowerCase().includes(searchState.toLowerCase())
    )
    .sort((a, b) => a.name.localeCompare(b.name)); // Sort states alphabetically

  return (
    <>
      <ToastContainer />
      <div className="log-in-container log-in-container-registration ">
        {!isSubmitted ? (
          <div className="row login-white-background-registration">
            <div className="col-lg-6 loginRath-image-right"></div>
            <div className="col-lg-6 d-flex justify-content-center align-items-center login-card">
              <div className="login-div">
                <form
                  onSubmit={handleSubmit}
                  className="mt-4 edit-profile-wrapper login-form"
                >
                  <h4
                    className="login-welcome-text"
                    style={{
                      fontSize: "34px",
                      textAlign: "center",
                      marginTop: "-35px",
                    }}
                  >
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 153 131"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M136.598 42.7996C132.574 49.254 132.605 56.3065 128.425 66.3816C125.368 66.0667 122.311 65.9408 119.253 66.0667C119.721 63.6424 119.94 61.1866 119.909 58.7308C119.815 53.8822 119.316 49.0336 118.411 44.2794C124.401 43.1145 130.484 42.6107 136.598 42.7996ZM117.039 59.6439C117.039 61.8478 116.851 64.0517 116.446 66.2241C108.241 66.8853 100.349 69.7189 93.5484 74.4101C99.3819 68.0188 102.626 59.6439 102.657 50.9541C102.657 50.6708 102.657 50.4189 102.626 50.1355C106.588 47.8057 110.831 46.074 115.26 44.9721C116.259 49.8207 116.851 54.7323 117.039 59.6439ZM89.8673 78.4087C97.4166 72.521 106.494 69.0577 116.009 68.3651C113.295 78.5976 105.839 82.6906 99.9434 82.6906C96.1376 82.6906 92.5189 81.1478 89.8673 78.4087ZM100.599 53.5988C100.599 64.3665 94.609 72.2692 89.337 77.3697C88.5883 75.6065 88.2139 73.7489 88.2451 71.8284C88.2451 65.3426 91.9886 57.4399 100.536 51.5208C100.599 52.2135 100.599 52.9062 100.599 53.5988ZM87.0909 71.5135C87.0909 73.0878 87.3405 74.662 87.8708 76.1418C86.3734 73.2452 85.5935 70.0023 85.5935 66.7279C85.5935 56.0546 90.3664 46.074 96.7615 37.9825C98.5396 41.5402 99.7251 45.3499 100.318 49.254C92.1134 54.8267 87.0909 62.6034 87.0909 71.5135ZM91.8638 81.1163C94.2659 82.785 97.1358 83.6981 100.037 83.761C109.24 83.761 116.134 78.0308 118.754 68.2077C121.656 68.1132 124.588 68.2391 127.489 68.554C127.489 68.5855 127.458 68.5855 127.458 68.5855C122.404 79.6366 112.952 85.4927 103.656 85.4927C99.3195 85.6816 95.0769 84.1074 91.8638 81.1163ZM115.416 21.9568C113.202 28.7575 113.857 35.81 114.917 42.6422C110.581 43.8386 106.432 45.5703 102.533 47.8371C102.096 43.4923 100.91 39.2419 99.0388 35.2748C103.718 29.9539 109.271 25.4201 115.416 21.9568ZM85.4063 13.3301C87.4964 22.555 92.1758 29.1038 95.7944 36.0304C90.6472 42.4533 87.0597 50.0096 85.4063 58.1011H85.5935V13.3301H85.4063ZM92.5189 82.6906C95.9192 85.3353 100.068 86.7521 104.342 86.7521C114.512 86.7521 124.525 80.8645 130.453 68.9318C135.413 69.7189 140.31 71.0098 144.99 72.8044C134.414 75.638 122.903 88.5467 108.429 88.5467C101.784 88.5467 96.4184 86.3113 92.8933 82.9424L92.5189 82.6906ZM84.1585 68.3336C86.0302 79.668 94.7962 90.2154 109.926 90.2154C127.395 90.2154 142.276 73.8119 152.321 73.3711C153.069 73.3396 153.069 72.9933 152.477 72.7729C145.738 69.9393 138.719 67.9243 131.513 66.7909C135.881 56.8102 135.974 48.1205 140.186 41.3198C140.56 40.7216 140.498 40.5327 139.811 40.4698C132.543 39.8401 125.212 40.3123 118.068 41.8866C116.851 34.1728 115.947 26.6166 118.879 17.9583C119.097 17.2971 118.973 16.9823 118.286 17.2971C110.612 21.2957 103.78 26.7425 98.1029 33.2913C93.33 23.657 86.3734 14.7784 84.4705 1.0196C84.3457 0.169515 83.9089 0.232484 83.9089 1.0196V63.7683C83.9089 69.2781 80.1031 71.8284 76.4844 71.8284C72.8657 71.8284 69.0599 69.2467 69.0599 63.7683V1.05108C69.0599 0.263968 68.6232 0.200999 68.4984 1.05108C66.5954 14.7784 59.6388 23.6885 54.8971 33.2913C49.2195 26.711 42.3565 21.2957 34.7136 17.2971C34.0585 16.9823 33.9026 17.2656 34.1209 17.9583C37.0845 26.648 36.1798 34.1728 34.932 41.8866C27.7882 40.3123 20.4573 39.8401 13.1887 40.4698C12.5336 40.5327 12.4712 40.7216 12.8144 41.3198C17.0258 48.1205 17.1506 56.8102 21.4867 66.7909C14.2806 67.9243 7.2304 69.9393 0.523362 72.7729C-0.069353 73.0248 -0.069353 73.3711 0.679339 73.3711C10.6931 73.7804 25.6045 90.2154 43.074 90.2154C58.235 90.2154 66.9698 79.668 68.8415 68.3336L68.5296 68.3966C69.7462 71.1672 72.3666 73.0248 75.3614 73.2452L75.3926 73.0563C71.2748 73.4971 67.968 76.6455 67.968 80.6756C67.968 87.0984 74.2072 89.1764 76.0477 94.025C76.1725 94.3399 76.2349 94.6862 76.5156 94.6862C76.7964 94.6862 76.8276 94.3713 76.9836 94.025C78.8553 89.1764 85.0632 87.0984 85.0632 80.6756C84.876 76.5826 81.6629 73.2767 77.6387 73.0563L77.6698 73.2452C80.6646 73.0248 83.285 71.1672 84.5017 68.3966L84.1585 68.3336ZM34.5889 44.3109C33.6842 49.065 33.1851 53.9137 33.0915 58.7623C33.0915 61.2181 33.3098 63.6739 33.7466 66.0982C30.6894 65.9723 27.6323 66.0667 24.5751 66.413C20.3949 56.338 20.4261 49.2854 16.4019 42.8311C22.485 42.6107 28.5681 43.1145 34.5889 44.3109ZM37.7084 45.0035C42.1382 46.1055 46.3808 47.8686 50.3426 50.167C50.3426 50.4504 50.3114 50.7022 50.3114 50.9856C50.3114 59.6753 53.5869 68.0502 59.4205 74.4416C52.6199 69.7504 44.7274 66.9168 36.523 66.2556C36.1174 64.0832 35.9303 61.8793 35.9303 59.6753C36.1486 54.7323 36.7413 49.8522 37.7084 45.0035ZM53.0566 82.722C47.1606 82.722 39.7049 78.5976 36.9909 68.3966C46.5055 69.0578 55.5834 72.5525 63.1327 78.4401C60.4811 81.1478 56.8624 82.6906 53.0566 82.722ZM52.4639 51.5523C61.0114 57.4714 64.7549 65.3741 64.7549 71.8599C64.7861 73.749 64.4118 75.638 63.6631 77.4012C58.391 72.3007 52.4015 64.398 52.4015 53.6303C52.4015 52.9062 52.4015 52.2135 52.4639 51.5523ZM52.6822 49.2854C53.2438 45.3499 54.4604 41.5402 56.2385 38.014C62.6336 46.074 67.4065 56.0861 67.4065 66.7594C67.4065 70.0338 66.6266 73.2452 65.1293 76.1733C65.6596 74.6935 65.9091 73.1193 65.9091 71.545C65.9091 62.6034 60.8867 54.8267 52.6822 49.2854ZM49.3443 85.4927C40.0481 85.4927 30.5958 79.6366 25.5422 68.5855C25.5422 68.554 25.511 68.554 25.511 68.554C28.4121 68.2391 31.3133 68.1132 34.2457 68.2077C36.8661 78.0308 43.7603 83.761 52.963 83.761C55.8954 83.7295 58.7342 82.8165 61.1362 81.1163C57.9543 84.1074 53.6805 85.6816 49.3443 85.4927ZM53.9613 35.2748C52.0895 39.2419 50.9041 43.4923 50.4674 47.8371C46.5679 45.5703 42.4189 43.8386 38.0828 42.6422C39.1434 35.7786 39.7985 28.7575 37.5836 21.9568C43.7603 25.4516 49.2819 29.9539 53.9613 35.2748ZM67.3753 13.3301V58.1011H67.5625C65.9091 50.0096 62.3529 42.4533 57.1744 36.0304C60.7931 29.0723 65.4724 22.555 67.5625 13.3301H67.3753ZM60.1068 82.911C56.5817 86.2798 51.2161 88.5152 44.5714 88.5152C30.0967 88.5152 18.5856 75.6065 8.01028 72.8044C12.7208 71.0098 17.5873 69.7189 22.5474 68.9318C28.4745 80.8645 38.4883 86.7521 48.658 86.7521C52.9318 86.7521 57.112 85.3038 60.4811 82.6906L60.1068 82.911Z"
                        fill="#9F1D21"
                      />
                      <path
                        d="M43.0849 111.502C42.8042 111.533 42.6794 111.502 42.617 111.313C42.305 109.613 40.8388 108.385 39.1543 108.385C37.6881 108.196 36.3779 109.266 36.1907 110.715C36.1907 110.778 36.1907 110.872 36.1595 110.935C36.1595 112.824 37.7193 113.643 39.7782 114.304C42.7418 115.28 44.6759 116.508 44.6759 119.404C44.6759 122.301 42.4298 124.347 38.5616 124.347C37.0954 124.41 35.598 124.096 34.2566 123.497C33.9446 123.371 33.7263 123.12 33.6327 122.836C33.2895 121.797 33.1024 120.695 33.1336 119.593C33.1336 119.404 33.3207 119.341 33.5391 119.31C33.7575 119.278 33.9134 119.341 33.9446 119.499C34.5685 121.167 35.8788 123.403 38.4992 123.403C40.5581 123.403 41.8683 122.175 41.8683 120.506C41.8683 119.089 41.3692 117.925 38.624 117.011C35.8788 116.098 33.6015 114.65 33.6015 111.848C33.6015 109.424 35.5668 107.346 39.435 107.346C40.4957 107.377 41.5563 107.503 42.617 107.755C42.9913 107.849 43.0225 107.912 43.1161 108.164C43.3969 109.14 43.5217 110.148 43.5217 111.155C43.4905 111.376 43.3657 111.47 43.0849 111.502Z"
                        fill="#9F1D21"
                      />
                      <path
                        d="M87.3513 119.656C87.5697 119.688 87.6945 119.782 87.6633 119.908C87.5385 121.073 87.1954 122.238 86.6962 123.277C86.6027 123.466 86.4467 123.592 86.2283 123.655C84.7933 124.159 83.2959 124.41 81.7674 124.442C76.3705 124.442 72.2215 121.703 72.2215 115.91C72.2215 110.274 76.6201 107.314 81.705 107.314C83.3583 107.346 84.9805 107.598 86.5715 107.976C86.8834 108.038 86.9146 108.101 86.9458 108.385C86.977 109.077 87.0394 110.305 87.2578 111.785C87.289 111.943 87.1954 112.006 86.9458 112.069C86.6651 112.1 86.5403 112.069 86.5091 111.911C86.0723 109.676 84.0446 108.133 81.7986 108.322C78.7102 108.322 75.5906 110.526 75.5906 115.563C75.5906 120.79 78.835 123.371 81.9857 123.371C84.263 123.403 86.2907 121.923 87.0082 119.751C87.0082 119.656 87.133 119.625 87.3513 119.656Z"
                        fill="#9F1D21"
                      />
                      <path
                        d="M93.6216 115.941C93.7152 111.124 97.6147 107.283 102.388 107.377C107.036 107.44 110.81 111.25 110.873 115.941C110.748 120.758 106.755 124.536 101.982 124.41C97.4275 124.285 93.7464 120.569 93.6216 115.941ZM102.263 123.371C105.195 123.371 107.535 120.192 107.535 115.941C107.535 112.006 105.632 108.448 102.263 108.448C98.8937 108.448 96.9908 112.037 96.9908 115.941C96.9596 120.192 99.2992 123.371 102.263 123.371Z"
                        fill="#9F1D21"
                      />
                      <path
                        d="M20.8113 115.91V120.475C20.8113 123.088 20.593 123.151 19.4387 123.308L18.9084 123.371C18.7524 123.403 18.7212 123.56 18.7212 123.749C18.7524 123.938 18.7836 124.096 18.9396 124.064C18.9396 124.064 21.0609 124.001 22.2151 124.001C23.3694 124.001 25.4907 124.064 25.4907 124.064C25.6466 124.064 25.709 123.938 25.709 123.749C25.7402 123.56 25.6778 123.371 25.5219 123.371L24.9915 123.308C23.8373 123.151 23.6189 123.088 23.6189 120.475V111.344C23.6189 108.731 23.8373 108.668 24.9915 108.511L25.5219 108.448C25.6778 108.416 25.709 108.259 25.709 108.07C25.709 107.881 25.6466 107.755 25.4907 107.755C25.4907 107.755 23.3694 107.818 22.2151 107.818C21.0609 107.818 18.9396 107.755 18.9396 107.755C18.7836 107.755 18.7212 107.881 18.7212 108.07C18.69 108.259 18.7524 108.448 18.9084 108.448L19.4387 108.511C20.593 108.668 20.8113 108.731 20.8113 111.344V115.91Z"
                        fill="#9F1D21"
                      />
                      <path
                        d="M62.4885 122.679C62.7693 123.057 62.5509 123.246 62.239 123.308L61.6151 123.403C61.4591 123.434 61.4279 123.56 61.4591 123.781C61.4903 124.001 61.5527 124.127 61.6775 124.096C61.6775 124.096 63.7364 124.033 64.8594 124.033C66.0136 124.033 68.0725 124.096 68.0725 124.096C68.2285 124.096 68.2909 124.001 68.3221 123.749C68.3533 123.497 68.2597 123.371 68.1349 123.371C67.1367 123.403 66.2008 122.962 65.6081 122.175C64.0483 120.412 60.96 116.413 59.7121 114.745C59.5562 114.587 59.5562 114.304 59.7121 114.146L59.7433 114.115C60.4296 113.359 62.6757 111.061 63.674 110.148C64.6722 109.14 65.9824 108.542 67.3862 108.416C67.511 108.385 67.6046 108.227 67.5734 108.007C67.5422 107.818 67.4798 107.692 67.3238 107.724C67.3238 107.724 65.5769 107.787 64.641 107.787C63.7052 107.787 61.9582 107.724 61.9582 107.724C61.8022 107.724 61.7398 107.881 61.7398 108.038C61.7086 108.259 61.771 108.385 61.8958 108.416L62.5509 108.605C62.6757 108.637 62.7693 108.7 62.7693 108.826C62.8005 109.109 62.2702 109.707 61.5839 110.494C60.6168 111.596 58.9322 113.391 58.0276 114.272C57.2789 114.997 56.9669 115.123 56.6862 114.965C56.4678 114.871 56.3742 114.619 56.3742 113.863V111.281C56.3742 108.668 56.5926 108.605 57.7468 108.448L58.2771 108.385C58.4331 108.353 58.4643 108.196 58.4643 108.007C58.4331 107.818 58.4019 107.692 58.2459 107.692C58.2459 107.692 56.1247 107.755 54.9704 107.755C53.8162 107.755 51.6949 107.692 51.6949 107.692C51.5389 107.692 51.4765 107.818 51.4765 108.007C51.4453 108.196 51.5077 108.385 51.6637 108.385L52.194 108.448C53.3482 108.605 53.5666 108.668 53.5666 111.281V120.412C53.5666 123.025 53.3482 123.088 52.194 123.246L51.6637 123.308C51.5077 123.34 51.4765 123.497 51.4765 123.686C51.4765 123.875 51.5389 124.033 51.6949 124.001C51.6949 124.001 53.8162 123.938 54.9704 123.938C56.1247 123.938 58.2459 124.001 58.2459 124.001C58.4019 124.001 58.4643 123.875 58.4643 123.686C58.4955 123.497 58.4331 123.308 58.2771 123.308L57.7468 123.246C56.5926 123.088 56.3742 123.025 56.3742 120.412V116.76C56.3742 116.35 56.5302 116.099 56.7798 116.036C57.0605 115.973 57.2789 116.099 57.5596 116.413C58.901 117.893 61.4279 121.231 62.4885 122.679Z"
                        fill="#9F1D21"
                      />
                      <path
                        d="M119.857 111.187C122.945 114.398 127.718 119.971 131.337 124.347C131.493 124.536 131.649 124.568 131.961 124.442C132.242 124.316 132.273 124.222 132.273 124.001C132.21 122.773 132.179 121.608 132.179 120.506V112.163C132.179 109.266 132.398 108.7 133.552 108.542L134.082 108.479C134.238 108.448 134.269 108.29 134.269 108.101C134.269 107.913 134.207 107.755 134.051 107.787C133.115 107.85 132.211 107.85 131.587 107.85C130.931 107.85 129.777 107.818 128.841 107.787C128.685 107.787 128.623 107.913 128.623 108.101C128.592 108.29 128.685 108.479 128.81 108.479C130.744 108.574 130.994 108.983 130.994 112.163V119.845L131.181 119.656C127.625 116.004 124.318 112.163 121.23 108.101C121.074 107.881 121.043 107.787 120.762 107.818C119.358 107.881 117.954 107.881 116.55 107.787C116.394 107.755 116.332 107.913 116.332 108.101C116.301 108.29 116.363 108.448 116.519 108.479C118.391 108.857 118.921 109.424 118.921 111.376V119.719C118.921 122.616 118.703 123.183 117.549 123.34L117.018 123.403C116.862 123.434 116.831 123.592 116.831 123.781C116.831 123.97 116.894 124.127 117.049 124.096C117.985 124.033 118.89 124.033 119.514 124.033C120.169 124.033 121.043 124.064 121.978 124.096C122.134 124.096 122.197 123.97 122.197 123.781C122.228 123.592 122.166 123.403 122.01 123.403L121.479 123.34C120.325 123.183 120.107 122.616 120.107 119.719V111.061L119.857 111.187Z"
                        fill="#9F1D21"
                      />
                      <path
                        d="M134.111 102.858C134.392 102.858 134.61 102.543 134.61 102.039C134.61 101.536 134.392 101.221 134.111 101.221H18.9062C18.6255 101.221 18.4071 101.536 18.4071 102.039C18.4071 102.543 18.6255 102.858 18.9062 102.858H134.111Z"
                        fill="#9F1D21"
                      />
                      <path
                        d="M134.111 130.596C134.392 130.596 134.61 130.281 134.61 129.777C134.61 129.274 134.392 128.959 134.111 128.959H18.9062C18.6255 128.959 18.4071 129.274 18.4071 129.777C18.4071 130.281 18.6255 130.596 18.9062 130.596H134.111Z"
                        fill="#9F1D21"
                      />
                      <path
                        d="M144.585 96.609C144.616 98.498 143.15 100.041 141.278 100.072C139.406 100.104 137.877 98.624 137.846 96.7349C137.815 94.8458 139.281 93.3031 141.153 93.2716C141.184 93.2716 141.215 93.2716 141.215 93.2716C143.056 93.2716 144.585 94.7514 144.585 96.609ZM138.657 96.609C138.751 98.0258 139.936 99.1277 141.371 99.0648C142.775 98.9703 143.867 97.7739 143.805 96.3256C143.742 94.9403 142.619 93.8698 141.247 93.8698C139.78 93.9328 138.626 95.1292 138.657 96.609ZM140.124 95.8533C140.124 95.507 140.061 95.3496 139.843 95.3181H139.749C139.687 95.2236 139.687 95.0662 139.78 95.0347C140.311 95.0033 140.779 94.9718 141.215 94.9718C141.808 94.9718 142.526 95.0977 142.526 95.8533C142.526 96.1682 142.338 96.4515 142.058 96.5775C141.995 96.609 141.995 96.6404 142.058 96.7664C142.214 97.1442 142.432 97.522 142.713 97.8054C142.806 97.8684 142.869 97.9313 142.931 97.9628C142.994 97.9628 142.994 98.1202 142.931 98.1517C142.806 98.1517 142.682 98.1832 142.557 98.1832C142.151 98.2147 141.777 97.9943 141.59 97.648L141.215 96.9868C141.184 96.8923 141.091 96.8294 140.997 96.8294C140.872 96.8294 140.841 96.8923 140.841 96.9553V97.3331C140.841 97.7109 140.841 97.8369 141.215 97.8683L141.278 97.8998C141.34 97.9313 141.34 98.1202 141.278 98.1517C141.028 98.1517 140.81 98.1202 140.498 98.1202C140.217 98.1202 139.968 98.1517 139.749 98.1517C139.687 98.1202 139.687 97.9313 139.718 97.8998L139.812 97.8683C140.092 97.8054 140.092 97.7424 140.092 97.3331L140.124 95.8533ZM140.841 96.3571C140.841 96.546 140.872 96.546 141.153 96.546C141.434 96.5775 141.652 96.3571 141.683 96.1052C141.683 96.0737 141.683 96.0422 141.683 96.0422C141.683 95.6329 141.496 95.3811 141.184 95.3811C140.872 95.3811 140.841 95.444 140.841 95.57V96.3571Z"
                        fill="#9F1D21"
                      />
                    </svg>
                    &nbsp;
                    <p className="login-welcome-text">Rath Yatra</p>
                    <div className="px-1 px-md-1 w-full">
                      <h4
                        className="login-welcome-sub-text"
                        style={{
                          fontSize: "14px",
                          marginTop: "10px",
                          lineHeight: "15px",
                        }}
                      >
                        Please share details of Rath Yatra’s conducted by your
                        temple from 27th June to 6th July 2025.{" "}
                        <b>
                          Kindly note that each temple should submit the details
                          only once.
                        </b>
                      </h4>
                    </div>
                    {/* ICC Brihad Mridanga */}
                  </h4>

                  {/* Phone and Temple Fields */}
                  <div className="row">
                    {formData.userrole !==
                      "GBC (Governing Body Commission)" && (
                      <div className="col-12 col-md-6 mb-3">
                        <label htmlFor="temple_name" className="form-label">
                          {t("Name of Temple")}
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip-top">
                                If your temple is not listed here, please select
                                'Other' and mention your temple name.
                              </Tooltip>
                            }
                          >
                            <span
                              className="tooltip-icon"
                              style={{
                                cursor: "pointer",
                                marginLeft: "8px", // Adds space between the text and the icon
                                fontSize: "1.2rem", // Increases the icon size
                                textDecoration: "none", // Ensures no underline or unwanted text decoration
                              }}
                            >
                              <i className="bi bi-info-circle"></i>{" "}
                              {/* Using Bootstrap Icons for the info icon */}
                            </span>
                          </OverlayTrigger>
                        </label>

                        <select
                          className="form-select"
                          style={{
                            cursor: "pointer",
                            backgroundColor: "",
                            opacity: 1,
                          }}
                          id="temple_name"
                          name="temple_name"
                          value={formData.temple_name}
                          onChange={handleTempleChange}
                          required
                        >
                          {formData.userrole === "Regional Secretary" ||
                          formData.userrole === "Regional Zonal Secretary" ? (
                            <option value="Other">{t("Other")}</option>
                          ) : (
                            <>
                              <option value="" disabled>
                                {t("Select Temple")}
                              </option>
                              {filteredTemples.map((temple, index) => (
                                <option key={index} value={temple.templeName}>
                                  {temple.templeName}
                                </option>
                              ))}
                              <option value="Other">{t("Other")}</option>
                            </>
                          )}
                        </select>

                        {(formData.userrole === "Regional Secretary" ||
                          formData.userrole === "Regional Zonal Secretary" ||
                          formData.temple_name === "Other") && (
                          <div className="mt-2">
                            {/* Conditional Label */}
                            <label
                              htmlFor="customTemple"
                              className="form-label"
                            >
                              {formData.userrole === "Regional Secretary" ? (
                                <>
                                  {t(
                                    "Please mention the list of temples in your zone. If the entire state is in your zone, just enter the state name."
                                  )}
                                </>
                              ) : formData.userrole ===
                                "Regional Zonal Secretary" ? (
                                <>
                                  {t(
                                    "Please mention the list of temples in your zone."
                                  )}
                                </>
                              ) : (
                                <>{t("Enter List Of Temple")}</>
                              )}
                            </label>

                            {/* Input Field */}
                            <input
                              type="text"
                              className="form-control"
                              id="customTemple"
                              name="customTemple"
                              value={formData.customTemple}
                              onChange={handleChange}
                              placeholder={t("Enter Temple Name")}
                              required={formData.temple_name === "Other"}
                            />
                          </div>
                        )}
                      </div>
                    )}

                    {/* Temple Category Field */}
                    {!(
                      formData.userrole === "GBC (Governing Body Commission)" ||
                      formData.userrole === "Regional Zonal Secretary" ||
                      formData.userrole === "Regional Secretary"
                    ) && (
                      <div className="col-12 col-md-6 mb-3">
                        <label htmlFor="catogory" className="form-label">
                          {t("Temple Category")}
                        </label>
                        <select
                          className="form-select"
                          id="catogory"
                          name="catogory"
                          value={formData.catogory}
                          onChange={handleChange}
                          required
                          style={{
                            cursor: "pointer",
                            backgroundColor: "",
                            opacity: 1,
                          }}
                        >
                          <option value="" disabled>
                            {t("Select Category")}
                          </option>
                          <option value="BT"> Big Temple (40+ devotees)</option>
                          <option value="MT">
                            Medium Temple (20 to 40 devotees)
                          </option>
                          <option value="ST">
                            Small Temple (5 to 20 devotees)
                          </option>
                          <option value="PC">Preaching Centre</option>
                          <option value="EC">Extension Centre</option>
                          <option value="OP">Outpost Centre</option>
                        </select>
                      </div>
                    )}
                  </div>

                  {/* Role and Zone Fields */}
                  <div className="row">
                    {formData.userrole === "GBC (Governing Body Commission)" ? (
                      // Checkbox for GBC role
                      <div className="col-12 col-md-6 mb-3">
                        <label htmlFor="zoneCheckbox" className="form-label">
                          {t("Zone Selection")}
                        </label>
                        <div className="row">
                          <div className="col-6 mb-2">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="eastZone"
                                name="zone"
                                value="East Zone"
                                checked={formData.selectedZones?.includes(
                                  "East Zone"
                                )}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "East Zone")
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="eastZone"
                              >
                                {t("East Zone")}
                              </label>
                            </div>
                          </div>
                          <div className="col-6 mb-2">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="northZone"
                                name="zone"
                                value="North Zone"
                                checked={formData.selectedZones?.includes(
                                  "North Zone"
                                )}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "North Zone")
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="northZone"
                              >
                                {t("North Zone")}
                              </label>
                            </div>
                          </div>
                          <div className="col-6 mb-2">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="southZone"
                                name="zone"
                                value="South Zone"
                                checked={formData.selectedZones?.includes(
                                  "South Zone"
                                )}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "South Zone")
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="southZone"
                              >
                                {t("South Zone")}
                              </label>
                            </div>
                          </div>
                          <div className="col-6 mb-2">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="westZone"
                                name="zone"
                                value="West Zone"
                                checked={formData.selectedZones?.includes(
                                  "West Zone"
                                )}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "West Zone")
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="westZone"
                              >
                                {t("West Zone")}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      !(
                        formData.userrole === "Regional Zonal Secretary" ||
                        formData.userrole === "Regional Secretary"
                      ) && (
                        // Dropdown for other roles
                        <div className="col-12 col-md-6 mb-3">
                          <label htmlFor="zone" className="form-label">
                            {t("Zone")}
                          </label>
                          <select
                            className="form-select"
                            id="zone"
                            name="zone"
                            value={formData.zone}
                            onChange={handleChange}
                            required
                          >
                            <option value="" disabled>
                              {t("Select Zone")}
                            </option>
                            <option value="EZ">{t("East Zone")}</option>
                            <option value="NZ">{t("North Zone")}</option>
                            <option value="SZ">{t("South Zone")}</option>
                            <option value="WZ">{t("West Zone")}</option>
                          </select>
                        </div>
                      )
                    )}

                    {!(
                      formData.userrole === "GBC (Governing Body Commission)" ||
                      formData.userrole === "Regional Zonal Secretary" ||
                      formData.userrole === "Regional Secretary"
                    ) && (
                      <div className="col-12 col-md-6 mb-3">
                        <label htmlFor="state" className="form-label">
                          {t("State")}
                        </label>
                        <select
                          className="form-select"
                          id="state"
                          name="state"
                          value={formData.state}
                          onChange={handleChange}
                          required
                        >
                          <option value="" disabled>
                            {t("Select State")}
                          </option>
                          {filteredStates.map((state) => (
                            <option key={state.name} value={state.name}>
                              {state.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    {/* Name Fields */}

                    {/* <div className="col-12 col-md-6 mb-3">
                      <label htmlFor="role" className="form-label">
                        {t("Role")}
                      </label>
                      <select
                        className="form-select"
                        id="userrole"
                        name="userrole"
                        value={formData.userrole}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>
                          {t("Select Role")}
                        </option>
                        <option value="Vice President">Vice President</option>
                        <option value="Temple President">
                          Temple President
                        </option>
                        <option value="Chairman of TMC">Chairman of TMC</option>
                        <option value="General Manager">General Manager</option>
                        <option value="Sevak Head">Sankirtan Leader</option>
                        <option value="Outpost Manager">Outpost Manager</option>
                      </select>
                    </div> */}
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6 mb-3">
                      <label
                        htmlFor="numberInput"
                        className="form-label"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {t("Count of Rath Yatras conducted")}
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="numberInput"
                        name="count"
                        min="1"
                        max="99"
                        value={formData.count}
                        onChange={(e) => {
                          const rawValue = e.target.value;

                          // Allow empty string so user can delete and retype
                          if (rawValue === "") {
                            setFormData((prev) => ({ ...prev, count: "" }));
                            return;
                          }

                          const numericValue = parseInt(rawValue, 10);

                          // Prevent 0 or out-of-range values
                          if (
                            !isNaN(numericValue) &&
                            numericValue >= 1 &&
                            numericValue <= 99
                          ) {
                            setFormData((prev) => ({
                              ...prev,
                              count: numericValue,
                            }));
                          }
                        }}
                        placeholder="Enter the count"
                      />
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                      <label htmlFor="name" className="form-label">
                        {t("Your Name")}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        placeholder={t("Enter Name")}
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="row">
                    {/* <div className="col-12 col-md-6 mb-3">
                      <label htmlFor="email" className="form-label">
                        {t("Email")}
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder={t("Enter Email")}
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div> */}
                    <div className="col-12 col-md-6 mb-3">
                      <label htmlFor="phone" className="form-label">
                        {t("Your Phone No.")}
                      </label>
                      <input
                        type="tel"
                        className="form-control"
                        id="phone"
                        name="phone"
                        placeholder={t("Enter Phone Number")}
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                      <label
                        htmlFor="phone"
                        className="form-label"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {t("Prominent Personality in Attendance")}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="personality"
                        name="personality"
                        placeholder={t("Enter Details")}
                        value={formData.personality}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6 mb-3">
                      <label
                        htmlFor="mediaCoverage"
                        className="form-label d-block text-nowrap"
                      >
                        {t("Media Coverage of Rath Yatra")}
                      </label>
                      <select
                        className="form-select"
                        id="mediaCoverage"
                        name="mediaCoverage"
                        value={formData.mediaCoverage}
                        onChange={handleChange}
                        required
                      >
                        <option value="">{t("Select an option")}</option>
                        <option value="yes">{t("Yes")}</option>
                        <option value="no">{t("No")}</option>
                      </select>
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                      <label
                        htmlFor="image"
                        className="form-label d-flex align-items-center"
                      >
                        {t("Upload Images")}
                        {/* <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="tooltip-upload-note">
                              <strong>NOTE:</strong> If parent temple is adding
                              the count of Rath Yatra’s conducted by
                              preaching/extension/outposts, those centers should
                              not make separate submissions.
                            </Tooltip>
                          }
                        >
                          <span
                            className="tooltip-icon"
                            style={{
                              cursor: "pointer",
                              marginLeft: "8px",
                              fontSize: "1.2rem",
                              textDecoration: "none",
                            }}
                          >
                            <i className="bi bi-info-circle"></i>
                          </span>
                        </OverlayTrigger> */}
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        id="images"
                        name="images"
                        accept="image/*"
                        multiple
                        onChange={(e) => {
                          const files = Array.from(e.target.files);
                          if (files.length > 4) {
                            alert("You can upload a maximum of 4 images.");
                            e.target.value = null; // Clear the input if over limit
                            setSelectedImages([]); // Optionally reset selection state
                          } else {
                            setSelectedImages(files);
                          }
                        }}
                      />
                    </div>
                  </div>

                  {/* State Field */}

                  {/* Submit Button */}
                  <div className="col-6 text-center">
                    <div className="col-6 text-center">
                      <button
                        type="submit"
                        className="btn btn-primary btn-block login-button"
                      >
                        {t("Submit")}
                      </button>
                    </div>
                  </div>
                  <p className="mt-4">
                    <strong>NOTE:</strong> If parent temple is adding the count
                    of Rath Yatra’s conducted by preaching /extension /outposts,
                    those centers should not make separate submissions.
                  </p>
                </form>
              </div>
              {showOtpModal && (
                <div
                  className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                  style={{
                    backdropFilter: "blur(5px)", // 👈 blur effect
                    backgroundColor: "rgba(0, 0, 0, 0.4)", // dark overlay
                    zIndex: 1050,
                  }}
                >
                  <div className="modal show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Enter OTP</h5>
                          <button
                            type="button"
                            className="btn-close"
                            onClick={() => setShowOtpModal(false)}
                          ></button>
                        </div>
                        <div className="modal-body">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter OTP"
                            value={otpInput}
                            onChange={(e) => setOtpInput(e.target.value)}
                          />
                        </div>
                        <div className="modal-footer">
                          <button
                            className="btn btn-primary btn-block login-button"
                            onClick={handleOtpVerifyAndSubmit}
                          >
                            Verify & Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div
            className="login-white-background-registration d-flex justify-content-center align-items-center"
            style={{
              height: "400px", // fixed height
              backgroundColor: "#fff", // white background
              textAlign: "center",
              borderRadius: "12px", // optional rounded corners
              padding: "20px",
              boxShadow: "0 0 10px rgba(0,0,0,0.1)", // optional subtle shadow
            }}
          >
            <div className="thank-you-message">
              <h3>
                {t("Thank you for registering for the Ratha Yatra Seva Score.")}
              </h3>
              <p>
                {t("In case of any queries please contact us on 7387470108.")}
              </p>
            </div>
          </div>
        )}

        {/* <div className="thank-you-message mt-6 text-center">
          {!isSubmitted && (
            <>
              <p>
                {t("In case of any queries, please contact us on 7387470108.")}
              </p>
            </>
          )}
        </div> */}
      </div>
    </>
  );
}
